"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientBFFClient = void 0;
const http_client_1 = require("@finbackoffice/http-client");
class ClientBFFClient extends http_client_1.HTTPClient {
    headers = {};
    setToken(token) {
        if (typeof window === "undefined") {
            this.headers.Cookie = `jwt=${token};`;
        }
    }
    setHeaders(headers) {
        this.headers = {
            ...this.headers,
            ...headers,
        };
    }
    async register(request) {
        const session = await this.send({
            method: "POST",
            path: "registration",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    validatePhone() {
        return this.send({
            method: "POST",
            path: "registration/validate-phone",
            headers: this.headers,
        });
    }
    validateEmail() {
        return this.send({
            method: "POST",
            path: "registration/validate-email",
            headers: this.headers,
        });
    }
    async checkPhone(request) {
        const session = await this.send({
            method: "POST",
            path: "registration/validate-phone/check",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    async checkEmail(request) {
        const session = await this.send({
            method: "POST",
            path: "registration/validate-email/check",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    profile() {
        return this.send({
            method: "GET",
            path: "profile",
            headers: this.headers,
        });
    }
    updateProfile(request) {
        return this.send({
            method: "PUT",
            path: "profile",
            headers: this.headers,
            body: request,
        });
    }
    async login(request) {
        const session = await this.send({
            method: "POST",
            path: "login",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    async logout() {
        await this.send({
            method: "POST",
            path: "logout",
            headers: this.headers,
        });
        this.setToken("");
    }
    loginOtp(request) {
        return this.send({
            method: "POST",
            path: "login-otp",
            headers: this.headers,
            body: request,
        });
    }
    banks() {
        return this.send({
            method: "GET",
            path: "payment/bank",
            headers: this.headers,
        });
    }
    cryptoDetails() {
        return this.send({
            method: "GET",
            path: "payment/crypto-details",
            headers: this.headers,
        });
    }
    queryDeposits(request) {
        return this.send({
            method: "PUT",
            path: "payment/deposit",
            headers: this.headers,
            body: request,
        });
    }
    initiateDeposit(request) {
        return this.send({
            method: "POST",
            path: "payment/deposit",
            headers: this.headers,
            body: request,
        });
    }
    updateDeposit(id, request) {
        return this.send({
            method: "PUT",
            path: "payment/deposit/:id",
            headers: this.headers,
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    queryWithdrawals(request) {
        return this.send({
            method: "PUT",
            path: "payment/withdrawal",
            headers: this.headers,
            body: request,
        });
    }
    createWithdrawal(request) {
        return this.send({
            method: "POST",
            path: "payment/withdrawal",
            headers: this.headers,
            body: request,
        });
    }
    get24HoursWithdrawalRemainder() {
        return this.send({
            method: "GET",
            path: "payment/withdrawal/24-hours",
            headers: this.headers,
        });
    }
    get24HoursDepositRemainder() {
        return this.send({
            method: "GET",
            path: "payment/deposit/24-hours",
            headers: this.headers,
        });
    }
    queryPaymentsTransactions(request) {
        return this.send({
            method: "PUT",
            path: "payment/transaction",
            headers: this.headers,
            body: request,
        });
    }
    initiatePhoneVerification() {
        return this.send({
            method: "POST",
            path: "payment/initiate-phone-verification",
            headers: this.headers,
        });
    }
    initiateEmailVerification() {
        return this.send({
            method: "POST",
            path: "payment/initiate-email-verification",
            headers: this.headers,
        });
    }
    addUserPaymentAccount(request) {
        return this.send({
            method: "POST",
            path: "payment/user-account/address",
            headers: this.headers,
            body: request,
        });
    }
    getUserPaymentAccount(currency) {
        return this.send({
            method: "GET",
            path: "payment/user-account/address/:currency",
            headers: this.headers,
            params: {
                currency: currency.toString(),
            },
        });
    }
    createReferral(request) {
        return this.send({
            method: "POST",
            path: "referral",
            headers: this.headers,
            body: request,
        });
    }
    findReferral() {
        return this.send({
            method: "GET",
            path: "referral",
            headers: this.headers,
        });
    }
    createReferredUser(request) {
        return this.send({
            method: "POST",
            path: "referral/user",
            headers: this.headers,
            body: request,
        });
    }
    queryReferredUser(request) {
        return this.send({
            method: "PUT",
            path: "referral/user",
            headers: this.headers,
            body: request,
        });
    }
    getReferralPersonalReport(bonusId) {
        return this.send({
            method: "GET",
            path: "referral/report/:bonusId",
            headers: this.headers,
            params: {
                bonusId: bonusId.toString(),
            },
        });
    }
    getBonuses(type, vertical, count) {
        return this.send({
            method: "GET",
            path: "bonus/:type/:vertical/:count",
            headers: this.headers,
            params: {
                type: type,
                vertical: vertical,
                count: count.toString(),
            },
        });
    }
    payBonus(bonusId) {
        return this.send({
            method: "POST",
            path: "bonus/:bonusId/pay",
            headers: this.headers,
            params: {
                bonusId: bonusId.toString(),
            },
        });
    }
    queryBonusPayment(request) {
        return this.send({
            method: "POST",
            path: "bonus/payment",
            headers: this.headers,
            body: request,
        });
    }
    getSiteConfig() {
        return this.send({
            method: "GET",
            path: "config/site",
            headers: this.headers,
        });
    }
    getAgentConfig() {
        return this.send({
            method: "GET",
            path: "config/agent",
            headers: this.headers,
        });
    }
    updateAgentConfig(request) {
        return this.send({
            method: "PUT",
            path: "config/agent",
            headers: this.headers,
            body: request,
        });
    }
    getPaymentsPeriodConfig() {
        return this.send({
            method: "GET",
            path: "config/paymentsPeriod",
            headers: this.headers,
        });
    }
    updatePaymentsPeriodConfig(request) {
        return this.send({
            method: "PUT",
            path: "config/paymentsPeriod",
            headers: this.headers,
            body: request,
        });
    }
    createChat(request) {
        return this.send({
            method: "POST",
            path: "chat",
            headers: this.headers,
            body: request,
        });
    }
    updateChat(id, request) {
        return this.send({
            method: "PUT",
            path: "chat/:id",
            headers: this.headers,
            params: {
                id: id.toString(),
            },
            body: request,
        });
    }
    updateChatBulk(request) {
        return this.send({
            method: "PUT",
            path: "chat/bulk",
            headers: this.headers,
            body: request,
        });
    }
    findChat(id) {
        return this.send({
            method: "GET",
            path: "chat/:id",
            headers: this.headers,
            params: {
                id: id.toString(),
            },
        });
    }
    deleteChat(id) {
        return this.send({
            method: "DELETE",
            path: "chat/:id",
            headers: this.headers,
            params: {
                id: id.toString(),
            },
        });
    }
    deleteChatBulk(request) {
        return this.send({
            method: "DELETE",
            path: "chat/bulk",
            headers: this.headers,
            body: request,
        });
    }
    getChatStats() {
        return this.send({
            method: "GET",
            path: "chat/stats",
            headers: this.headers,
        });
    }
    createMessage(chatId, request) {
        return this.send({
            method: "POST",
            path: "chat/:chatId/message",
            headers: this.headers,
            params: {
                chatId: chatId.toString(),
            },
            body: request,
        });
    }
    updateMessage(chatId, messageId, request) {
        return this.send({
            method: "PUT",
            path: "chat/:chatId/message/:messageId",
            headers: this.headers,
            params: {
                chatId: chatId.toString(),
                messageId: messageId.toString(),
            },
            body: request,
        });
    }
    queryChat(request) {
        return this.send({
            method: "PUT",
            path: "chat",
            headers: this.headers,
            body: request,
        });
    }
    queryMessage(chatId) {
        return this.send({
            method: "GET",
            path: "chat/:id/message",
            headers: this.headers,
            params: {
                id: chatId.toString(),
            },
        });
    }
    searchMessage(query) {
        return this.send({
            method: "GET",
            path: "chat/message/search",
            headers: this.headers,
            query: {
                query: query,
            },
        });
    }
    queryTransaction(request) {
        return this.send({
            method: "PUT",
            path: "transaction",
            headers: this.headers,
            body: request,
        });
    }
    queryCasinoGames(request) {
        return this.send({
            method: "PUT",
            path: "casino/game",
            headers: this.headers,
            body: request,
        });
    }
    getCasinoGames(request) {
        return this.send({
            method: "GET",
            path: "casino/game",
            query: {
                page: request.page.toString(),
                items_per_page: request.items_per_page.toString(),
                id: request.id,
                mobile: request.mobile.toString(),
                megaways: request.megaways?.toString(),
                has_jackpot: request.has_jackpot?.toString(),
                bonusbuy: request.bonusbuy?.toString(),
                types: request.types?.length ? request.types : undefined,
                name: request.name,
                category: request.category,
                tag: request.tag,
            },
        });
    }
    getCasinoGameSummaryByCategory(request) {
        return this.send({
            method: "GET",
            path: "casino/game/summary-by-category",
            query: {
                mobile: request.mobile.toString(),
                megaways: request.megaways?.toString(),
                has_jackpot: request.has_jackpot?.toString(),
                bonusbuy: request.bonusbuy?.toString(),
                types: request.types.length ? request.types : undefined,
                tag: request.tag,
            },
        });
    }
    getCasinoEnums() {
        return this.send({
            method: "GET",
            path: "casino/enums",
            headers: this.headers,
        });
    }
    createCasinoRealSession(request) {
        return this.send({
            method: "POST",
            path: "casino/session/real",
            headers: this.headers,
            body: request,
        });
    }
    createCasinoFunSession(request) {
        return this.send({
            method: "POST",
            path: "casino/session/fun",
            headers: this.headers,
            body: request,
        });
    }
    queryCasinoBets(request) {
        return this.send({
            method: "PUT",
            path: "casino/bet",
            headers: this.headers,
            body: request,
        });
    }
    createCasinoFavorite(request) {
        return this.send({
            method: "POST",
            path: "casino/favorite",
            headers: this.headers,
            body: request,
        });
    }
    findCasinoFavoriteByUserId(mobile) {
        return this.send({
            method: "GET",
            path: "casino/favorite",
            headers: this.headers,
            query: {
                mobile: mobile.toString(),
            },
        });
    }
    deleteCasinoFavorite(gameId, mobile) {
        return this.send({
            method: "DELETE",
            path: "casino/favorite/:gameId",
            headers: this.headers,
            params: {
                gameId: gameId,
            },
            query: {
                mobile: mobile.toString(),
            },
        });
    }
    queryTickets(request) {
        return this.send({
            method: "PUT",
            path: "ticket",
            headers: this.headers,
            body: request,
        });
    }
    createTicket(request) {
        return this.send({
            method: "POST",
            path: "ticket",
            headers: this.headers,
            body: request,
        });
    }
    calculateMaxBet(request) {
        return this.send({
            method: "PUT",
            path: "ticket/max",
            headers: this.headers,
            body: request,
        });
    }
    getWinningTickets() {
        return this.send({
            method: "GET",
            path: "ticket/winning-tickets",
            headers: this.headers,
        });
    }
    validateCryptoAddress(currency, address) {
        return this.send({
            method: "GET",
            path: "crypto/validate/:currency/:address",
            headers: this.headers,
            params: {
                currency: currency.toString(),
                address: address,
            },
        });
    }
    getUserCryptoAddressTag() {
        return this.send({
            method: "GET",
            path: "crypto/address/tag",
            headers: this.headers,
        });
    }
    updateUserCryptoAddressTag(request) {
        return this.send({
            method: "POST",
            path: "crypto/address/tag",
            headers: this.headers,
            body: request,
        });
    }
    getPotentialCryptoNetworkFee(currency) {
        return this.send({
            method: "GET",
            path: "crypto/fee/:currency",
            headers: this.headers,
            params: {
                currency: currency.toString(),
            },
        });
    }
    getPublicNotifications(request) {
        return this.send({
            method: "GET",
            path: "notification/public/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                tags: request.tags.length ? request.tags : undefined,
            },
        });
    }
    getLoggedInNotifications(request) {
        return this.send({
            method: "GET",
            path: "notification/loggedIn/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                tags: request.tags.length ? request.tags : undefined,
            },
        });
    }
    getPublicPopups(request) {
        return this.send({
            method: "GET",
            path: "popup/public/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                tags: request.tags.length ? request.tags : undefined,
            },
        });
    }
    getLoggedInPopups(request) {
        return this.send({
            method: "GET",
            path: "popup/loggedIn/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                tags: request.tags.length ? request.tags : undefined,
            },
        });
    }
    createFile(request) {
        const body = new FormData();
        body.append("path", request.path);
        body.append("file", request.body, request.filename);
        return this.send({
            method: "POST",
            path: "document/file",
            headers: this.headers,
            body: body,
        });
    }
    createDocument(request) {
        return this.send({
            method: "POST",
            path: "document",
            headers: this.headers,
            body: request,
        });
    }
    getUserDocuments() {
        return this.send({
            method: "GET",
            path: "document",
            headers: this.headers
        });
    }
    getBanners(request) {
        return this.send({
            method: "GET",
            path: "banner/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                tags: request.tags.length > 0 ? request.tags : undefined,
                provider: request.provider,
                equal: request.equal?.toString(),
            },
        });
    }
    getReels(request) {
        return this.send({
            method: "GET",
            path: "reel/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                tags: request.tags.length > 0 ? request.tags : undefined,
                provider: request.provider,
                equal: request.equal?.toString(),
            },
        });
    }
    getReel(language, reel_id) {
        return this.send({
            method: "GET",
            path: "reel/:language/:id",
            headers: this.headers,
            params: {
                language: language.toString(),
                id: reel_id.toString(),
            },
        });
    }
    addReelLike(reel_id) {
        return this.send({
            method: "POST",
            path: "reel/:id/like",
            headers: this.headers,
            params: {
                id: reel_id.toString(),
            },
        });
    }
    initiateRecovery(request) {
        return this.send({
            method: "POST",
            path: "recovery/initiate",
            headers: this.headers,
            body: request,
        });
    }
    validateRecoveryToken(request) {
        return this.send({
            method: "POST",
            path: "recovery/validate",
            headers: this.headers,
            body: request,
        });
    }
    async completeRecovery(request) {
        const session = await this.send({
            method: "POST",
            path: "recovery/complete",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    changePassword(request) {
        return this.send({
            method: "POST",
            path: "profile/change-password",
            headers: this.headers,
            body: request,
        });
    }
    getCasinoWinningBets(request) {
        return this.send({
            method: "GET",
            path: "casino-stats/bets",
            headers: this.headers,
            query: {
                game_id: request?.game_id ?? "",
            },
        });
    }
    getDesktopTranslations(request) {
        return this.send({
            method: "GET",
            path: "user-interface/desktop/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                scopes: request.scopes,
            },
        });
    }
    getMobileTranslations(request) {
        return this.send({
            method: "GET",
            path: "user-interface/mobile/:language",
            headers: this.headers,
            params: {
                language: request.language.toString(),
            },
            query: {
                scopes: request.scopes,
            },
        });
    }
    getExternalUserByCPFNumber(cpf_number) {
        return this.send({
            method: "GET",
            path: "registration/external/:cpf_number",
            headers: this.headers,
            params: {
                cpf_number,
            },
        });
    }
    async registerFromCPFUser(request) {
        const session = await this.send({
            method: "POST",
            path: "registration/cpf/without-verification",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    async registerFromCPFNumber(request) {
        const session = await this.send({
            method: "POST",
            path: "registration/cpf/with-verification",
            headers: this.headers,
            body: request,
        });
        if (typeof session.token === "string") {
            this.setToken(session.token);
        }
        return session;
    }
    queryFreeRoundUser(query) {
        return this.send({
            method: "PUT",
            path: "casino/free-round-user",
            headers: this.headers,
            body: query,
        });
    }
}
exports.ClientBFFClient = ClientBFFClient;
//# sourceMappingURL=client.js.map